import BigNumber from 'bignumber.js'
import { PERCENT_DECIMALS_MULTIPLIER } from './constants'

export const percentFromString = (value: string, dp: [number, BigNumber.RoundingMode] = [8, 1]) =>
  new BigNumber(value)
    .multipliedBy(PERCENT_DECIMALS_MULTIPLIER)
    .dp(...dp)
    .toNumber()
